<template>
  <div class="flex w-full p-4 rounded-xl">
    <div class="flex flex-col items-center text-13 w-full h-full font-semibold">
      <div class="flex items-center self-stretch justify-between">
        <p class="flex text-primary-100 text-lg font-semibold leading-26 items-center self-stretch">Okuma Listem</p>
        <a v-if="isLoggedIn" :href="`/${PROFILE_PATH}/${user.username}${articleCount > 0 ? '/' + FAVORITE_PATH : ''}`">Tümünü gör</a>
      </div>
      <div class="border-b border-black/[0.05] w-full my-4"></div>
      <div v-if="userFavorites.length === 0" class="u-center flex-col">
        <OImage src="/images/not-found.svg" class="mb-4 w-[118px] h-[108px]" />
        <p class="self-stretch text-[#C4C4C4] text-center text-md font-medium">
          Henüz okuma listenize kaydettiğiniz bir içerik yok. İlginizi çekecek içerikleri keşfedin ve kaydedin!
        </p>
      </div>
      <div v-else class="flex flex-col gap-4 w-full">
        <ReadingListSidebarItem v-for="article in userFavorites" :key="article._id" :article="article" />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, useContext, onMounted, ref, computed } from '@nuxtjs/composition-api';
import { truncate } from 'lodash';
import ReadingListSidebarItem from './ReadingListSidebarItem.vue';
import { useAuth } from '~/modules/auth/state/useAuth';
import { PROFILE_PATH, FAVORITE_PATH } from '~/constants/config';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    ReadingListSidebarItem,
    OImage,
  },
  setup() {
    const { user, isLoggedIn } = useAuth();
    const { $service } = useContext();
    const userFavorites = ref([]);
    const articleCount = computed(() => user.value.stats?.articles);

    onMounted(async () => {
      if (isLoggedIn.value) {
        const response = await $service.profile.getUserFavorites({ userId: user.value?._id });
        userFavorites.value = response.data?.slice(0, 3);
      }
    });

    return { userFavorites, user, PROFILE_PATH, FAVORITE_PATH, isLoggedIn, truncate, articleCount };
  },
});
</script>
